<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>category</md-icon>
          </div>
          <h4 class="title">我的組合</h4>
        </md-card-header>

        <md-card-content v-if="myPackage.id">
          <div class="text-right">
            <md-button href="/my-packages" class="md-primary md-dense">
              上一頁
            </md-button>
          </div>

          <div class="md-layout-item md-medium-size-100 md-small-size-100 md-xsmall-size-100 md-size-100">
            <md-card class="md-layout-example">
              <md-card-area md-inset>
                <md-card-media md-ratio="16:9">
                  <img :src=myPackage.package.image>
                </md-card-media>

                <md-card-header>
                  <h2 class="md-title">{{ myPackage.package_name }}</h2>
                  <div class="md-subhead">
                    <md-icon>shopping_cart</md-icon>
                    <span> 組合數量 : {{ myPackage.item_amount }}</span>
                  </div>
                  <div class="md-subhead">
                    <md-icon>back_hand</md-icon>
                    <span class="text-warning"> 領取數量 : {{ myPackage.item_used }}</span>
                  </div>
                  <div class="md-subhead">
                    <md-icon>deck</md-icon>
                    <span class="text-success"> 剩餘數量 : {{ myPackage.item_last || '' }}</span>
                  </div>
                  <div class="md-subhead">
                    <md-icon>schedule</md-icon>
                    領取期限 : <span class="text-danger"> {{ myPackage.expire_at }}</span>
                  </div>
                  <div class="md-subhead">
                    <md-icon>room</md-icon>
                    <span> 購買門市 : {{ myPackage.sold_store_name }}</span>
                  </div>

                </md-card-header>
                <md-card-content v-show="myPackage.refund_status > 0">

                  <div class="md-subhead">
                    <md-icon></md-icon>
                    <span> 購買金額 : {{ myPackage.package.price }}</span>
                  </div>
                  <div class="md-subhead">
                    <md-icon></md-icon>
                    <span> 單片原價 : {{ myPackage.package.item_price }}</span>
                  </div>
                  <div class="md-subhead">
                    <md-icon></md-icon>
                    <span> 未領數量 : {{ myPackage.item_refund }}</span>
                  </div>

                  <div class="md-subhead">
                    <md-icon></md-icon>
                    寄庫已兌換金額 : <span class="title text-danger"> {{ myPackage.package.item_price * myPackage.item_used }}</span>
                  </div>
                  <div v-show="myPackage.refund_balance < 1" class="md-subhead">
                    <md-icon></md-icon>
                    寄庫已為您節省金額 : <span class="title text-danger"> {{ Math.abs(myPackage.refund_balance) }}</span>
                  </div>

                  <div class="md-subhead">
                    <md-icon></md-icon>
                    退款金額 : <span class="text-danger"> {{ myPackage.refund_total }}</span>
                  </div>

                  <div v-show="myPackage.refund_status == 1" class="md-subhead">
                    <md-icon></md-icon>
                    <span class="title text-danger"> 請到門市辦理退款 </span>
                  </div>

                  <div v-show="myPackage.refund_status == 2" class="md-subhead">
                    <md-icon></md-icon>
                    門市啟動退款日期 : <span class="text-danger"> {{ myPackage.refund_start_at }}</span>
                  </div>

                  <div v-show="myPackage.refund_status == 2" class="md-subhead">
                    <md-icon></md-icon>


                    <md-button
              class="md-danger"
              @click.native="refundConfirm"
              >退款確認</md-button
            >

                  </div>


                  <div v-show="myPackage.refund_status == 9" class="md-subhead">
                    <md-icon></md-icon>
                    退款日期 : <span class="text-danger"> {{ myPackage.refund_at }}</span>
                  </div>
                </md-card-content>
              </md-card-area>
            </md-card>
          </div>
        </md-card-content>

      </md-card>
    </div>

    <!-- 商品 客戶端先不 show 2021-12-28 會議 jay 決定 -->
    <div class="md-layout-item md-size-100" v-if="false && products.length">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>waving_hand</md-icon>
          </div>
          <h4 class="title">商品</h4>
        </md-card-header>

        <md-card-content>
          <md-table  class="table-shopping">
            <md-table-row  v-for="(item, index) in products" :key="index">
              <md-table-cell md-label="圖片">
                <div class="img-container">
                  <img :src="item.image" alt="products" />
                </div>
              </md-table-cell>
              <md-table-cell md-label="名稱" class="td-name">
                <a >{{ item.name }}</a>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>

      </md-card>
    </div>

    <div class="md-layout-item md-size-100" v-if="usedLog.length">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">領取記錄</h4>
        </md-card-header>

        <md-card-content>
          <md-table  class="table-shopping">
            <md-table-row  v-for="(item, index) in myPackage.used_log" :key="index">
              <md-table-cell md-label="日期">
                <div class="img-container">
                  {{ item.created_at | formatDate }}
                </div>
              </md-table-cell>
              <md-table-cell md-label="領取門市">
                <div class="img-container">
                  {{ item.used_store_name }}
                </div>
              </md-table-cell>
              <md-table-cell md-label="名稱" class="td-name">
                <h5 >{{ idGetProductName(item.product_id) }}</h5>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>

  </div>
</template>

<script>
import _ from "lodash";
import Pagination from "@/components/Pagination";
import Swal from "sweetalert2";

export default {
  components: {
  },

  data: () => ({
    id: 0,
    myPackage: {id: 0},
    package: null,
    products: [],
    usedLog: [],

    table: [],
    footerTable: [
      "Name",
      "Category",
      "Picture",
      "Tags",
      "Created At",
      "Actions",
    ],

    query: null,

    sortation: {
      field: "created_at",
      order: "asc",
    },

    pagination: {
      perPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50],
    },

    total: 0,
  }),

  computed: {
    sort() {
      if (this.sortation.order === "desc") {
        return `-${this.sortation.field}`;
      }

      return this.sortation.field;
    },

    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    sortation: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
  },
  created() {
    this.get();
  },

  methods: {
    idGetProductName: function(productId) {
      const product = _.find(this.products, { 'id': productId});
      return (product) ? product.name : '';
    },
    async get() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("my_packages/get", id);
        const item = this.$store.getters["my_packages/item"];

        item.item_last = item.item_amount - item.item_used;

        this.myPackage = item || {};
        this.package = item.package || {};
        this.products = item.package.products || [];
        this.usedLog = item.used_log;

        // this.item.tags.forEach((tag) => {
        //   this.tags.push(tag.id);
        // });
      } catch (e) {
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
      }
    },

    async refundConfirm() {
      try {
        const payload = {
          user_package_id: this.$route.params.id,
        }

        await this.$store.dispatch("my_packages/refund_confirm", payload);

        this.get();

        await this.$store.dispatch(
          "alerts/success",
          "退款確認成功！"
        );

      } catch (e) {
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
      }
    },


    async destroy(id) {
      if (this.$isDemo == 1 && ["1", "2"].includes(id)) {
        await this.$store.dispatch(
          "alerts/error",
          "You are not allowed to change data of default items."
        );
        return;
      }
      const confirmation = await Swal.fire({
        title: "Delete this item?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
      });

      if (confirmation.value === true) {
        try {
          await this.$store.dispatch("items/destroy", id);
          await this.$store.dispatch(
            "alerts/success",
            "Item deleted successfully."
          );
          await this.getList();
        } catch (e) {
          if (e.response.data.errors[0]) {
            await this.$store.dispatch(
              "alerts/error",
              e.response.data.errors[0].title
            );
          } else {
            await this.$store.dispatch(
              "alerts/error",
              "Oops, something went wrong!"
            );
          }
        }
      }
    },

    goToAdd() {
      this.$router.push({ name: "Add Item" });
    },

    goToEdit(id) {
      this.$router.push({ name: "Edit Item", params: { id } });
    },

    customSort() {
      return false;
    },
  },
};
</script>
